export default function items(simulation, item) {
  return simulation.items.reduce((v, i) => v + (i.type === item ? i.value : 0), 0);
}
